"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(library) {
    return ['FUNCTION', 'DELETE', library];
}
exports.transformArguments = transformArguments;
